import React, { useEffect, useState } from 'react'
import supportimg from '../../assets/images/support-img.png'
import { fynitoApi } from '../Services/axios';
import toastify from '../../helper/toastify';
import { Link, useLocation } from 'react-router-dom';
import MobileBottomBar from '../Layout/MobileBottomBar';

function Support() {
    const [supprotList, setSupportList] = useState([]);
    const location = useLocation();
    const orderId = location.state;
    // Fetch Support Api
    const fetchSupportList = async () => {
        try {
            const res = await fynitoApi.get('/faq-list');
            if (res.data.status_code === 200) {
                // Filter for User role FAQs and set the list
                const userFaqs = res.data.data.filter(faq => faq.role_id === "User");
                setSupportList(userFaqs);
            } else {
                toastify.error(res.data.message);
            }
        } catch (error) {
            console.error('Error fetching FAQ list:', error);
            toastify.error('Failed to load support options. Please try again.');
        }
    }
    

    useEffect(() => {
        fetchSupportList();
    }, [])
    return (
        <>
            <section className="support-sec tp-space">
                <div className="container">
                    <div className="support-innr">
                        <h1>Support And Help</h1>
                        <img src={supportimg} alt="supportimg" />
                    </div>
                </div>
            </section>
            <section className="faq-sec tp-space">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12 col-sm-12">
                            <div className="accordion" id="faq">
                                {
                                    supprotList.length > 0 ? (
                                        supprotList.map((support, index) => {
                                            // Strip HTML tags from answer for display and chat message
                                            const stripHtml = (html) => {
                                                const tmp = document.createElement("DIV");
                                                tmp.innerHTML = html;
                                                return tmp.textContent || tmp.innerText || "";
                                            };
                                            const answerText = stripHtml(support.answer);
                                            
                                            return (
                                                <div key={support.id} className="accordion-item">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#faq-${support.id}`}>
                                                            {support.question}
                                                        </button>
                                                    </h2>
                                                    <div id={`faq-${support.id}`} className="accordion-collapse collapse show" data-bs-parent="#faq">
                                                        <div className="accordion-body">
                                                            <div dangerouslySetInnerHTML={{ __html: support.answer }} />
                                                            <Link className="thm-btn fill-btn mt-2" to="/chat" state={{ orderId: orderId, initialMessage: answerText }}>Chat With us</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <div className="text-center py-5">
                                            <p>No support options available at the moment.</p>
                                            <Link className="thm-btn fill-btn mt-2" to="/chat" state={{ orderId: orderId }}>Chat With us</Link>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default Support